import { useState, useEffect, useCallback } from "react";
import { getCompanyDetails } from "../api/demaService";
import { SimilarCompaniesResponse } from "../types/interfaces";

const useCompanyDetails = (reportId: string) => {
  const [data, setData] = useState<SimilarCompaniesResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const fetchDetails = useCallback(async () => {
    if (!reportId) return;
    setLoading(true);
    try {
      const result = await getCompanyDetails(reportId);
      setData(result);
      setError("");
    } catch (e: any) {
      setError(e.message || "Error fetching company details");
    } finally {
      setLoading(false);
    }
  }, [reportId]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  return { data, loading, error, fetchDetails };
};

export default useCompanyDetails;
